import { Avatar, AvatarProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const UserAvatar = (props: AvatarProps) => {
  return <Avatar {...props} icon={props.icon ?? <UserOutlined />} />;
};

export default UserAvatar;
